<template>
  <div class="excellent-capabilities">
    <introduce />
    <instructions />
    <serverList />
  </div>
</template>

<script>
import introduce from './components/introduce'
import instructions from './components/instructions'
import serverList from './components/serverList'

export default {
  name: 'Excellent',
  components: {
    introduce,
    instructions,
    serverList
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.excellent-capabilities {
  .excellent-capabilities-introduce {
    margin-bottom: var(--base-size-16);
  }

  .excellent-capabilities-instructions {
    margin-bottom: var(--base-size-16);
  }
}
</style>
